import React from 'react';
import {
  Button, Col, Heading, Radio, Row
} from '@thd-olt-component-react/core-ui';
import PropTypes from 'prop-types';
import { MobileAwareOverlay } from '../../../components/MobileAwareOverlay';
import './confirmAddressModal.scss';
import { AddressType } from './types';
import {
  IconWithRoundBorder
} from '../IconWithRoundBorder/IconWithRoundBorder';
import { formatAddress } from './common';
import { addAnalyticEvent } from '../../analytics/common';
import { confirmAddressOverlay } from '../../analytics/address';
import LinkButton from '../LinkButton';

const MOBILE_CONFIRM_BUTTON_TEXT = 'Confirm Verified';
const DESKTOP_CONFIRM_BUTTON_TEXT = 'Confirm';

export const ConfirmAddressModal = ({
  unsubscribeAddress, unsubscribeVerifiedAddress, confirmUseUnverified, isMobile, onClose,
  useVerifiedAddress, address, tryAgainButton
}) => {

  React.useEffect(() => {
    addAnalyticEvent(confirmAddressOverlay);
  }, []);

  const getConfirmButtonText = () => {
    return isMobile && useVerifiedAddress ? MOBILE_CONFIRM_BUTTON_TEXT : DESKTOP_CONFIRM_BUTTON_TEXT;
  };

  return (
    <MobileAwareOverlay
      modalClass="preferences-modal"
      onClose={onClose}
      open
    >
      <Row className="preferences-modal__content">
        <Col>
          <Row>
            <Col className="modal-title modal-title--with-round-icon">
              {!isMobile && (
                <IconWithRoundBorder
                  iconSrc="https://assets.homedepot-static.com/images/v1/mailbox.svg"
                  iconWidth="27.7px"
                />
              )}
              <h1>{useVerifiedAddress ? 'Confirm' : 'Verify'} Your Mailing Address</h1>
            </Col>
          </Row>
          <Row className="text">
            <Col>
              <h3 className="epc-bold-text">
                The address entered
                {useVerifiedAddress ? ' matched the ' : ' did not match a '}
                verified address provided by United Parcel Service (UPS).
                If you have received information from us in the past, enter your address
                exactly as it appears on the correspondence. Any errors may prevent removal
                from our mailing list.{' '}
              </h3>
              {!isMobile && (<br />)}
              <h3>
                Please confirm the correct address, use the entered address or{' '}
                <LinkButton onClick={tryAgainButton} testId="verified-try-again">
                  try again
                </LinkButton>
                .
              </h3>
            </Col>

          </Row>
          <br />
          <h3>
            <strong>{useVerifiedAddress ? 'Verified' : 'Entered'} Mailing Address</strong>
          </h3>
          <Row>
            <Col>
              <Radio
                className="radio-container col__12-12"
                id={0}
                checked
                value="Verified"
                onChange={() => {}}
              >
                {formatAddress(address)}
              </Radio>
            </Col>
          </Row>
          <hr className="hr-line" />
          <Row>
            {!isMobile && <Col nopadding md={useVerifiedAddress ? 4 : 8} />}
            {useVerifiedAddress && (
              <Col md={4} fallback={6}>
                <Button
                  name="unverified"
                  data-testid="unverified"
                  onClick={confirmUseUnverified}
                  outline
                >
                  Use Unverified{isMobile && ' Address'}
                </Button>
              </Col>
            )}
            <Col md={4} fallback={useVerifiedAddress ? 6 : 12}>
              <Button onClick={useVerifiedAddress ? unsubscribeVerifiedAddress : unsubscribeAddress}>
                {getConfirmButtonText()}
              </Button>
            </Col>
          </Row>
        </Col>
      </Row>
    </MobileAwareOverlay>
  );
};

ConfirmAddressModal.propTypes = {
  tryAgainButton: PropTypes.func.isRequired,
  address: AddressType.isRequired,
  onClose: PropTypes.func.isRequired,
  useVerifiedAddress: PropTypes.bool.isRequired,
  isMobile: PropTypes.bool,
  confirmUseUnverified: PropTypes.func.isRequired,
  unsubscribeVerifiedAddress: PropTypes.func.isRequired,
  unsubscribeAddress: PropTypes.func.isRequired,
};

ConfirmAddressModal.defaultProps = {
  isMobile: false,
};
